import React, { useMemo, useState } from 'react';
import { useMediaQuery } from 'react-responsive';
import { useAppSelector } from 'Douleutaras/redux/hooks';
import { sellerProfilesSelectors } from 'Douleutaras/redux/data/seller/sellerProfilesSlice';
import { getRelationEntitiesFromSingleEntity } from 'Douleutaras/redux/data/jobAttributes/jobAttributesSelectors';
import { sellerProfilesBadgesSelectors } from 'Douleutaras/redux/data/seller/sellerProfilesBadgesSlice';
import { TABLET_BIG } from 'Douleutaras/constants/media-queries';
import Modal from 'Douleutaras/components/Modal/Modal';
import DefaultModal from 'Douleutaras/components/modals/DefaultModal';
import { useTranslation } from 'react-i18next';

import './ProBadges.scss';

// Order of badges displayed. (by group)
const BADGES_ORDER_GROUP = [
  'top_pro',
  'top_service',
  'top_of_class',
  'caring_pro'
];

// Sort badges by date and group.
const sortBadges = badges => () => {
  // @ts-ignore
  const badgesSortedByDate = badges?.sort((a, b) => new Date(b.attributes.created) - new Date(a.attributes.created));
  const badgesArrayOrder = [];

  BADGES_ORDER_GROUP.forEach(badgeGroup => {
    const filteredBadges = badgesSortedByDate?.filter(badge => badge.attributes?.group === badgeGroup);

    if (filteredBadges.length < 1) {
      return;
    }
    badgesArrayOrder.push(...filteredBadges);
  });

  return badgesArrayOrder;
};

const ProBadges = ({ username }) => {
  const isMobileResolution = useMediaQuery(
    { maxWidth: TABLET_BIG.MAX_WIDTH }
  );

  const { t } = useTranslation();

  const selectBadges = getRelationEntitiesFromSingleEntity(
    state => sellerProfilesSelectors.selectByUsername(state, username),
    state => sellerProfilesBadgesSelectors.selectAll(state),
    'badges'
    );
  const badges = useAppSelector(state => selectBadges(state));

  // Group and memoize badges in the order we want.
  const groupedBadges = useMemo(sortBadges(badges), [badges]);

  const [ activeBadgePopup, setActiveBadgePopup ] = useState();
  const activeBadgeImage = useMemo(() => badges?.find(badge => badge.id === activeBadgePopup), [activeBadgePopup]);

  return (
    <>
      {groupedBadges.map(badge => {
        return (
          <div styleName="badge__container" key={`key_badge${badge.id}`} onClick={() => setActiveBadgePopup(badge.id)}>
            <img styleName="badge__img"
                 src={isMobileResolution ? badge.attributes.iconAlt : badge.attributes.icon}
                 alt={badge.attributes.title} />
          </div>
        );
      })}
      <Modal isOpen={activeBadgePopup !== undefined}>
        <DefaultModal
          closeAriaLabel={t('Close window')}
          closeButtonCallback={() => setActiveBadgePopup(undefined)}
          showBackButton={false}
        >
          <article styleName="modal__wrapper">
            <div styleName="modal__badge-img-wrapper">
              <img styleName="badge__img badge__img--in-modal"
                   src={isMobileResolution ? activeBadgeImage?.attributes.iconAlt : activeBadgeImage?.attributes.icon}
                   alt={activeBadgeImage?.attributes.title} />
            </div>
            <h3 styleName="badge__header">
              {activeBadgeImage?.attributes.header}
            </h3>
            <div styleName="badge__description">
              {activeBadgeImage?.attributes.content}
            </div>
          </article>
        </DefaultModal>
      </Modal>
    </>
  );
};

export default ProBadges;
